import {
  HStack,
  VStack,
  Text,
  Pressable,
  Input,
  Box,
  Image,
  Divider,
  Button,
  AddIcon,
} from "native-base";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { Link as AVlink } from "../../AVCore/Link";
import AVCancel from "../../components/common/AVCancel";
import CreatePostpopup from "../../Screens/Home/CreatePostpopup";
import EditPostpopup from "../../Screens/Home/EditPostpopup";
import AVImageSlider from "../../components/common/AVImageSlider";
import { ScrollView } from "react-native-gesture-handler";
import report from "../../assets/images/report.png";
import startruck from "../../assets/images/startruck.svg";
import sads from "../../assets/images/sads.svg";
import fan from "../../assets/images/fan.svg";
import like from "../../assets/images/like.svg";
import Moment from "react-moment";
import ProfilePic from "../common/ProfilePicture";
import EntityProfilePic from "../common/EntityProfilePic";
import { Person } from "../../AVCore/AVCore";
import { useSelector, RootStateOrAny } from "react-redux";
import AVAdd from "../../components/common/AVAdd";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  MoreHorizontalIcon,
  LikeIcon,
  ReplyIcon,
  ChatIcon,
  CommentIcon,
  AddPhotoIcon,
  HappyIcon,
  PaperPlaneIcon,
  DeleteIcon,
  EditIcon,
  VideoIcon,
  TranslationIcon,
  CrossIcon,
  TickIcon,
} from "../../assets/icons/icon-assets";
import { Loc } from "../../App/Loc";
import Picker from "emoji-picker-react";
import AVEmojiPicker from "../../components/common/AVEmojiPicker";
import FilePicker from "../../Platform/FilePicker";
import useFillFeeds from "../../Hooks/useFillFeeds";
import { AHStack, AVBox, AVPressable, AVStack } from "../../components/ui";
import SvgIcon from "../../assets/icons";
import * as AV from "../../AVCore/AVCore";
import fallBackImage from "../../assets/images/avatar.png";
import LogoSvg from "../../assets/images/Actavivo-Logo.svg";
import { Dimensions } from "react-native";
import heart from "../../assets/images/heart.png";
import broken from "../../assets/images/broken.png";
import AVlinktext from "../common/AVlinktext";
import settings from "../../Platform/settings.json";
import Tooltip from "@mui/material/Tooltip";
import AVConverttime from "./AVConverttime";
import GridView from "./GridView";
import { View, TouchableOpacity, FlatList } from "react-native";
import LinkPreview from "../../components/common/preview/AVLinkPreview";
import LogoSvg1 from "../../assets/images/Actavivo-Logo.svg";
import { baseFontSize } from "native-base/lib/typescript/theme/tools";
import { IoClose } from "react-icons/io5";
import { sanitizedText } from "../../components/common/preview/utils/util";
import { setPostPopupExpanded } from "../../Redux/Actions/userActions";
import PostText from "../../components/common/preview/PostText";
import AVConfirmLinkPopup from "../../components/common/AVConfirmLinkPopup";

interface Impression {
  impression: string;
  user: string;
  timestamp?: string;
}

interface Item {
  impressions: Impression[];
}

interface InterfaceModalProps {
  visible?: boolean;
}

const Comment = ({
  showAddComment,
  setShowAddComment,
  SetType,
  setParentId,
  setCmdParent,
  ...props
}) => {
  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const postPopupExpanded = useSelector(
    (state: RootStateOrAny) => state.user.postPopupExpanded,
  );
  const isOnline = useSelector(
    (state: RootStateOrAny) => state.user.isOnline
  );
  const [videos, setvideos] = useState<any>([]);
  const [picker, setPicker] = useState(false);
  const [isImageProcessing, setIsImageProcessing] = useState(false);
  const [noticeMessage, setNoticeMessage] = useState<any>("");
  const [showAddMedia, setShowAddMedia] = useState(false);
  const dimension = Dimensions.get("window");
  const isMobile = dimension?.width <= 600 || false;
  const [showFeedbackImpressions, setShowFeedbackImpressions] = useState(false);
  const entitydatalist = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const [shiftPressed, setShiftPressed] = useState(false);

  const handleKeyPress = (e) => {
    const { key } = e.nativeEvent;
    if (key === "Shift") {
      setShiftPressed(true);
    } else if (key === "Enter" && !shiftPressed && !isMobile) {
      e.preventDefault();
      handlePostComment(false);
    } else {
      setShiftPressed(false);
    }
  };

  const emojiMapping: { [key: string]: string } = {
    Wow: settings.wow,
    Lol: settings.lol,
    Like: settings.like,
    Unlike: settings.unlike,
    Cheer: settings.cheer,
    Question: settings.question,
    Sad: settings.sad,
    heart: settings.heart,
    broken: settings.broken,
    Mad: settings.mad,
  };

  const EditPostMenu = ({
    item,
    showEditPopup,
    handleEditPost,
    currentUser,
    handleDeletePost,
    HandleReportComment,
    handleShowOriginalText,
    handleAcceptedPost,
  }) => {
    const menuRefs = useRef(null);
    useOutsideAlerter(menuRefs);
    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setShowEditPopup(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }

    const isOwnPost = currentUser?.id === item?.person?.id;
    const getBaseLang = (lang: any) => lang?.split("-")[0] || "";
    const isText = (text: string): boolean => {
      const textRegex = /\p{L}/u;
      return textRegex.test(text);
    };
    const stripHtml = (html: string): string =>
      html.replace(/<[^>]*>/g, "").trim();
    const hasRealText = (text: string): boolean => isText(stripHtml(text));

    let isTranslated =
      item?.isTranslateText !== undefined &&
      item?.ptype !== "W" &&
      item?.ptype !== "G"
        ? item.isTranslateText
        : false;
    const shouldTranslate =
      item?.id?.length > 0 && item?.text?.length > 0
        ? ((item?.text?.trim() !== "" &&
            hasRealText(item?.text?.trim()) &&
            item?.plang == undefined) ||
            getBaseLang(currentUser?.preferences?.lang) !==
              getBaseLang(item?.plang)) &&
          item?.text?.length > 0 &&
          item?.text?.trim() !== "" &&
          hasRealText(item?.text?.trim()) &&
          item?.ptype !== "W" &&
          item?.ptype !== "G"
        : false;

    return (
      <>
        {showEditPopup && (
          <VStack
            ref={menuRefs}
            position="absolute"
            width={
              isTranslated && !isOwnPost && shouldTranslate ? "180px" : "125px"
            }
            bgColor="#fff"
            borderColor="coolGray.200"
            borderWidth="1"
            shadow={1}
            zIndex={1}
            top="30px"
            right={1}
            borderRadius={5}
          >
            {/* OTHER USER ACTIONS */}
            {item?.person?.id !== currentUser?.id && (
              <>
                {isTranslated && !isOwnPost && (
                  <>
                    <Pressable
                      onPress={() => handleShowOriginalText(item)}
                      p={2}
                      _hover={{ backgroundColor: "AVColor.hovercolor2" }}
                    >
                      <HStack alignItems="center" space={2}>
                        <TranslationIcon
                          width="20px"
                          height="20px"
                          color="#000000"
                        />
                        <Text>{Loc.currentLang.menu.showOriginalTxt}</Text>
                      </HStack>
                    </Pressable>
                    <Divider thickness="0.5" />
                  </>
                )}

                <Pressable
                  onPress={() => HandleReportComment(item)}
                  p={2}
                  _hover={{ backgroundColor: "AVColor.hovercolor2" }}
                >
                  <HStack alignItems="center" space={2}>
                    <Image source={report} alt="report" size="15" />
                    <Text>{Loc.currentLang.menu.report}</Text>
                  </HStack>
                </Pressable>
              </>
            )}

            {/* OWN POST ACTIONS */}
            {item?.person?.id === currentUser?.id && (
              <>
                {/* Show Translation Option if needed */}
                {isTranslated && !isOwnPost && (
                  <>
                    <Pressable
                      onPress={() => handleShowOriginalText(item)}
                      p={2}
                      _hover={{ backgroundColor: "AVColor.hovercolor2" }}
                    >
                      <HStack alignItems="center" space={2}>
                        <TranslationIcon
                          width="20px"
                          height="20px"
                          color="#000000"
                        />
                        <Text>{Loc.currentLang.menu.showOriginalTxt}</Text>
                      </HStack>
                    </Pressable>
                    <Divider thickness="0.5" />
                  </>
                )}

                {/* Normal Edit/Delete Options */}
                {item.modStatus !== "NR" && (
                  <>
                    <Pressable
                      onPress={() => props?.handleEditPost(item)}
                      p={2}
                      _hover={{ backgroundColor: "AVColor.hovercolor2" }}
                    >
                      <HStack alignItems="center" space={2}>
                        <EditIcon size="18px" color="AVColor.secondaryText" />
                        <Text>{Loc.currentLang.menu.edit}</Text>
                      </HStack>
                    </Pressable>
                    <Divider thickness="0.5" />
                    <Pressable
                      onPress={() => props?.handleDeleteComment(item)}
                      p={2}
                      _hover={{ backgroundColor: "AVColor.hovercolor2" }}
                    >
                      <HStack alignItems="center" space={2}>
                        <DeleteIcon size="18px" color="AVColor.secondaryText" />
                        <Text>{Loc.currentLang.menu.delete}</Text>
                      </HStack>
                    </Pressable>
                  </>
                )}

                {/* NR Status - Moderation Actions */}
                {item.modStatus === "NR" && (
                  <>
                    <Pressable
                      onPress={() => handleAcceptedPost(item)}
                      p={2}
                      _hover={{ backgroundColor: "AVColor.hovercolor2" }}
                    >
                      <HStack alignItems="center" space={2}>
                        <TickIcon size="18px" color="AVColor.secondaryText" />
                        <Text>{Loc.currentLang.menu.accepted}</Text>
                      </HStack>
                    </Pressable>
                    <Divider thickness="0.5" />
                    <Pressable
                      onPress={() => props?.handleDeleteComment(item)}
                      p={2}
                      _hover={{ backgroundColor: "AVColor.hovercolor2" }}
                    >
                      <HStack alignItems="center" space={2}>
                        <CrossIcon size="18px" color="AVColor.secondaryText" />
                        <Text>{Loc.currentLang.menu.rejected}</Text>
                      </HStack>
                    </Pressable>
                  </>
                )}
              </>
            )}
          </VStack>
        )}
      </>
    );
  };

  const {
    item,
    setItem,
    isAddComment,
    commentValue,
    showFilePicker,
    handlePostComment,
    //calculateTimeDifference,
    //handleImpression,
    //handleImpressionpop,
    handleLikePost,
    showEmoji,
    setShowEmoji,
    handleFilePicker,
    getImageGalleryFromFilePickerCreateConvo,
    handleComment,
    showFBEmoji,
    setShowFBEmoji,
    showComment,
    setShowComment,
    handleConvoPostComment,
    handleEditPopup,
    setShowEditPopup,
    handleReplyPost,
    showEditPopup,
    handleDeletePost,
    handleEditPost,
    //handleReportPost,
    showEditPost,
    showModal,
    setShowModal,
    images,
    setImages,
    isDeleted,
    setShowEditPost,
    handleAddComment,
    textEditRef,
    setIsCommentLoading,
    isCommentLoading,
    handleEditComment,
    handleUpdatePost,
    editComment,
    showEditFilePicker,
    media,
    setCommentMedia,
    setCommentTo,
    handleEditFilePicker,
    onEmojiClick,
    handleremoveLike,
    handleTranslateText,
    handleShowOriginalText,
    handleAcceptedPost,
    HandleRejected,
    setpreviewitem,
    isLikeLoading,
    cmdParent,
    clickedUrl,
    setClickedUrl,
    showConfirmLinkPopup,
    setShowConfirmLinkPopup,
    paySend,
    setPaySend,
    subject,
    setSubject,
    estimate,
    setEstimate,
    showBoostPostPopup,
    setShowBoostPostPopup,
    showCreditsPopup,
    setShowCreditsPopup,
    sharedPlan,
    setSharedPlan,
  } = useFillFeeds(props, "feedComments");

  const navigate = useNavigate();
  const [position, setPosition] = useState<any>("top");
  const commentValueRef = useRef<HTMLInputElement>(null);
  const [commentItem, setCommentItem] = useState(item);
  const imageInputRef = useRef<HTMLInputElement>(null);
  const tooltipProps = {
    hasArrow: true,
    arrowSize: 15,
    offset: true,
    openDelay: 500,
    color: "white", // Text color of the tooltip
    fontSize: "md", // Font size of the tooltip text
    px: 4, // Horizontal padding of the tooltip
    py: 2, // Vertical padding of the tooltip
    _text: {
      textAlign: "center", // Text alignment within the tooltip
    },
    cursor: "default",
    zIndex: 999, // Remove the pointer cursor
  };
  const [commentValues, setCommentValue] = useState("");

  const handleImages = async (e: any) => {
    try {
      setIsCommentLoading(true);
      let files: any = Array.from(e?.target?.files);
      if (files.length > 20) {
        return;
      }
      setShowAddMedia(false);
      setPicker(false);
      files.forEach((img: any) => {
        if (
          img.type !== "image/jpeg" &&
          img.type !== "image/png" &&
          img.type !== "image/jfif" &&
          /*img.type !== 'image/webp' &&*/
          img.type !== "image/gif" &&
          img.type !== "video/mp4"
        ) {
          files = files.filter((item: any) => item.name !== img.name);
          return;
        } else {
          const reader = new FileReader();
          reader.readAsDataURL(img);
          reader.onload = (readerEvent: any) => {
            if (img.type.startsWith("image"))
              setImages((images) => [...images, readerEvent.target.result]);
            else setvideos((videos) => [...videos, readerEvent.target.result]);
          };
        }
      });
      setIsImageProcessing(true);
      setNoticeMessage("Please wait while we process your images...");
      await AV.Media.saveFiles(
        AV.Media.getFormData(files),
        currentUser?.region,
      ).then((data) => {
        if (data[0]?.status == "Invalid Size") {
          setNoticeMessage(Loc.currentLang.alertMessages.largeVideo);
          setIsImageProcessing(false);

          return;
        }

        setCommentMedia((prev) => [...prev, ...data]);
        setIsCommentLoading(false);
      });
      setNoticeMessage(null);
      setIsImageProcessing(false);
    } catch {
      setIsCommentLoading(false);
    }
  };

  const handleClick = () => {
    if (commentValueRef && commentValueRef.current) {
      commentValueRef.current.focus();
    }
  };
  const [imageUrls, setImagesUrl] = useState([]);
  const [videoUrls, setVideoUrl] = useState([]);
  const [showDetails, setShowDetails] = useState(false);

  const showVIDEODetails = async (item: any) => {
    setShowDetails(true);

    if (
      (item?.galleryPost && item?.galleryPost?.length > 0) ||
      (item?.media?.storeId && item?.media?.type?.startsWith("video"))
    ) {
      for (let i = 0; i < item?.galleryPost.length; i++) {
        media.push(item?.galleryPost[i].media);
      }
      if (item?.media?.storeId && item?.media?.type?.startsWith("video")) {
        media.push(item?.media);
        setVideoUrl(media);
      }
    }
  };

  useEffect(() => {
    if (
      (item?.galleryPost && item?.galleryPost?.length > 0) ||
      (item?.media?.storeId && item?.media?.type?.startsWith("image"))
    ) {
      for (let i = 0; i < item?.galleryPost?.length; i++) {
        media.push(item?.galleryPost[i].media);
      }
      if (item?.media?.storeId && item?.media?.type?.startsWith("image")) {
        media.push(item?.media);
      }
      let images = media.length && media.map((i) => AV.Media.getURL(i));
      setImagesUrl(images);
    }
  }, []);

  const menuRef = useRef(null);
  useOutsideAlerter(menuRef);
  //Hook that alerts clicks outside of the passed ref
  function useOutsideAlerter(ref) {
    useEffect(() => {
      // Alert if clicked on outside of element
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowEmoji(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useEffect(() => {}, [item]);

  const isOwnPost = currentUser?.id === item?.person?.id;
  const getBaseLang = (lang: any) => lang?.split("-")[0] || "";
  const isText = (text: string): boolean => {
    const textRegex = /\p{L}/u;
    return textRegex.test(text);
  };
  const stripHtml = (html: string): string =>
    html.replace(/<[^>]*>/g, "").trim();
  const hasRealText = (text: string): boolean => isText(stripHtml(text));

  let isTranslated =
    item?.isTranslateText !== undefined &&
    item?.ptype !== "W" &&
    item?.ptype !== "G"
      ? item.isTranslateText
      : false;
  const shouldTranslate =
    item?.id?.length > 0 && item?.text?.length > 0
      ? ((item?.text?.trim() !== "" &&
          hasRealText(item?.text?.trim()) &&
          item?.plang == undefined) ||
          getBaseLang(currentUser?.preferences?.lang) !==
            getBaseLang(item.plang)) &&
        item?.text?.length > 0 &&
        item?.text?.trim() !== "" &&
        hasRealText(item?.text?.trim()) &&
        item?.ptype !== "W" &&
        item?.ptype !== "G"
      : false;

  if (
    currentUser?.preferences?.autoTrans &&
    item?.isTranslateText === undefined &&
    shouldTranslate &&
    item?.text?.trim() !== "" &&
    item?.trans?.length > 0 &&
    item?.trans?.filter(
      (x) =>
        getBaseLang(x?.lang) == getBaseLang(currentUser?.preferences?.lang),
    ).length > 0
  ) {
    isTranslated = true;
    item.isTranslateText = true;
  }

  let text = item?.text ?? "";
  if (isTranslated && Array.isArray(item?.trans) && item.trans.length > 0) {
    const userLang = getBaseLang(currentUser?.preferences?.lang);
    const matchedTranslation = item.trans.find(
      (x: any) => getBaseLang(x?.lang) === userLang,
    );
    text = matchedTranslation?.text || text;
  }

  useEffect(() => {
    if (
      showModal ||
      showAddComment ||
      postPopupExpanded ||
      showBoostPostPopup
    ) {
      document.body.style.overflow = "hidden"; // disable scroll
    } else {
      document.body.style.overflow = "auto"; // enable scroll back
    }

    return () => {
      // cleanup to ensure scroll resets if component unmounts
      document.body.style.overflow = "auto";
    };
  }, [showModal, showAddComment, postPopupExpanded, showBoostPostPopup]);

  return (
    <>
      {showDetails && (
        <Box
          position={"fixed"}
          top={0}
          bottom={0}
          left={0}
          right={0}
          justifyContent={"space-between"}
          backgroundColor={"AVColor.overlay"}
          width={"100%"}
          zIndex={1000}
        >
          <div
            className={`show_post_details`}
            style={{
              maxWidth: "950px",
            }}
          >
            <ScrollView>
              <VStack padding={3} justifyContent={"space-between"}>
                <HStack justifyContent={"flex-end"}>
                  <AVCancel
                    size={undefined}
                    color={undefined}
                    callback={() => {
                      setShowDetails(false);
                      setpreviewitem([]);
                    }}
                  />
                </HStack>

                <HStack space={3}>
                  <VStack
                    flex={3}
                    padding={2.5}
                    alignItems={"flex-start"}
                    justifyContent={"flex-start"}
                    backgroundColor={"#000"}
                    borderRadius={3}
                  >
                    <div style={{ width: "100%", height: "100%" }}>
                      {videoUrls.length === 0 && (
                        <AVImageSlider
                          setCommentValue={setCommentValue}
                          slideItems={imageUrls}
                          previewitem={undefined}
                          setpreviewitem={undefined}
                          type={undefined}
                          settype={undefined}
                          fullscreen={undefined}
                          setIsFullScreen={undefined}
                          setShowDetails={undefined}
                          setIscommentItem={undefined}
                          setIsCommentSlider={undefined}
                          isCommentSlider={undefined}
                          handleslideChange={undefined}
                          isHeader={undefined}
                          setHeader={undefined}
                          setShowPreview={undefined}
                        />
                      )}

                      {videoUrls.length > 0 && (
                        <AVImageSlider
                          setCommentValue={setCommentValue}
                          slideItems={videoUrls}
                          previewitem={undefined}
                          setpreviewitem={undefined}
                          type={undefined}
                          settype={undefined}
                          fullscreen={undefined}
                          setIsFullScreen={undefined}
                          setShowDetails={undefined}
                          setIscommentItem={undefined}
                          setIsCommentSlider={undefined}
                          isCommentSlider={undefined}
                          handleslideChange={undefined}
                          isHeader={undefined}
                          setHeader={undefined}
                          setShowPreview={undefined}
                        />
                      )}
                    </div>
                  </VStack>

                  <VStack flex={1.5}>
                    <PostHeader
                      item={item}
                      setItem={setItem}
                      handleEditPopup={handleEditPopup}
                      showEditPopup={showEditPopup}
                      handleDeletePost={handleDeletePost}
                      handleEditPost={handleEditPost}
                      menuRef={menuRef}
                      handleremoveLike={handleremoveLike}
                      showModal={showModal}
                      setShowModal={setShowModal}
                      currentUser={currentUser}
                      handleDeleteComment={props?.handleDeleteComment}
                      handleLikePost={handleLikePost}
                      handleTranslateText={handleTranslateText}
                      handleShowOriginalText={handleShowOriginalText}
                      handleAcceptedPost={handleAcceptedPost}
                      userInfo={props?.Postdata}
                      isHuddlePostTab={props.isHuddlePostTab}
                      paySend={paySend}
                      setPaySend={setPaySend}
                      subject={subject}
                      setSubject={setSubject}
                      estimate={estimate}
                      setEstimate={setEstimate}
                      showBoostPostPopup={showBoostPostPopup}
                      setShowBoostPostPopup={setShowBoostPostPopup}
                      showCreditsPopup={showCreditsPopup}
                      setShowCreditsPopup={setShowCreditsPopup}
                      sharedPlan={sharedPlan}
                      setSharedPlan={setSharedPlan}
                      feedChunks={props?.feedChunks}
                      setFeedChunks={props?.setFeedChunks}
                    />

                    {/*{item?.ptype === "H" ? (*/}
                    {/*  <HtmlPostViewer text={item?.text} />*/}
                    {/*) : (*/}
                    {/*  <Box maxH={"100px"} overflow={"hidden"}>*/}
                    {/*    <Text>{item?.text}</Text>*/}
                    {/*  </Box>*/}
                    {/*)}*/}

                    <PostText
                      item={item}
                      currentUserId={currentUser?.id}
                      preferencesLang={currentUser?.preferences?.lang}
                      setClickedUrl={setClickedUrl}
                      setShowConfirmLinkPopup={setShowConfirmLinkPopup}
                    />

                    <Divider mt={1} />
                    <HStack>
                      <PostActions
                        item={item}
                        handleLikePost={handleLikePost}
                        handleReplyPost={handleReplyPost}
                        isLikeLoading={isLikeLoading}
                      />
                    </HStack>
                    <Divider />
                    <Box
                      ref={menuRef}
                      overflow={"hidden"}
                      overflowY={"scroll"}
                      height={"450px"}
                    >
                      {item?.children?.map((subitem) => (
                        <Comment
                          showAddComment={showAddComment}
                          setShowAddComment={setShowAddComment}
                          SetType={SetType}
                          setParentId={setParentId}
                          setCmdParent={setCmdParent}
                          subitem={subitem}
                          data={props}
                          key={subitem?.id}
                          handleEditPost={props?.handleEditPost}
                          handleDeleteComment={props?.handleDeleteComment}
                          HandleReportComment={props?.HandleReportComment}
                        />
                      ))}
                    </Box>
                  </VStack>
                </HStack>
              </VStack>
            </ScrollView>
          </div>
        </Box>
      )}

      <VStack paddingLeft={6} width={"100%"} justifyContent={"space-between"}>
        <Box key={item?.id} paddingX={"12px"}>
          <VStack width={"100%"} alignItems="flex-start">
            <HStack
              width={"100%"}
              space={2}
              alignSelf="flex-start"
              marginRight={4}
            >
              <Pressable
                onPress={() =>
                  navigate(
                    `/profile/${item?.person.id}/${item?.person?.region}`,
                    { state: { user: item.person } },
                  )
                }
              >
                <HStack>
                  <EntityProfilePic
                    width={38}
                    height={38}
                    link={
                      currentUser?.id == item?.person?.id
                        ? AV.AVEntity.getLink(currentUser)
                        : entitydatalist?.find(
                              (x: any) => x?.id == item?.person?.id,
                            )
                          ? AV.AVEntity.getLink(
                              entitydatalist?.find(
                                (x: any) => x?.id == item?.person?.id,
                              ),
                            )
                          : item?.person
                    }
                  />
                </HStack>
              </Pressable>

              <VStack
                flex={1}
                bgColor={"AVColor.hovercolor2"}
                p={1.5}
                px={2}
                alignSelf={"flex-start"}
                borderRightRadius={10}
                borderBottomRadius={10}
              >
                <HStack justifyContent={"space-between"}>
                  <Pressable
                    width={"20%"}
                    onPress={() =>
                      navigate(
                        `/profile/${item?.person.id}/${item?.person?.region}`,
                        { state: { user: item.person } },
                      )
                    }
                  >
                    <Text
                      fontSize={"16px"}
                      fontWeight={"500"}
                      color={"AVColor.primaryText"}
                      text-overflow={"ellipsis"}
                      numberOfLines={1}
                    >
                      {currentUser?.id == item?.person?.id
                        ? currentUser?.name
                        : entitydatalist?.find(
                              (x: any) => x?.id == item?.person?.id,
                            )
                          ? entitydatalist?.find(
                              (x: any) => x?.id == item?.person?.id,
                            ).name
                          : item?.person?.title}
                    </Text>
                    <Text fontSize={[10, 12]}>
                      <AVConverttime date={item?.createDate} page={"Post"} />
                    </Text>
                  </Pressable>

                  <HStack space={2} alignItems="center">
                    {!isTranslated && !isOwnPost && shouldTranslate && (
                      <Tooltip title={Loc.currentLang.menu.translateText} arrow>
                        <Pressable
                          onPress={() => handleTranslateText(item)}
                          _hover={{
                            backgroundColor: "#D3D3D3",
                            rounded: "full",
                          }}
                          p={2}
                        >
                          <TranslationIcon
                            width="20px"
                            height="20px"
                            color="#000000"
                          />
                        </Pressable>
                      </Tooltip>
                    )}

                    <Pressable
                      onPress={() => {
                        handleEditPopup(item);
                      }}
                      _hover={{ backgroundColor: "#D3D3D3", rounded: "full" }}
                      p={2}
                    >
                      <MoreHorizontalIcon
                        size={"18px"}
                        color={"AVColor.primaryText"}
                      />
                    </Pressable>
                  </HStack>
                </HStack>

                {/*{item?.ptype === "H" ? (*/}
                {/*  <HtmlPostViewer text={text} />*/}
                {/*) : (*/}
                {/*  <HStack top={"3px"}>*/}
                {/*    <Text*/}
                {/*      fontSize={"15px"}*/}
                {/*      color={"AVColor.secondaryText"}*/}
                {/*      numberOfLines={5}*/}
                {/*      lineHeight={"25"}*/}
                {/*    >*/}
                {/*      <AVlinktext text={text} />*/}
                {/*    </Text>*/}
                {/*  </HStack>*/}
                {/*)}*/}

                <PostText
                  item={item}
                  currentUserId={currentUser?.id}
                  preferencesLang={currentUser?.preferences?.lang}
                  setClickedUrl={setClickedUrl}
                  setShowConfirmLinkPopup={setShowConfirmLinkPopup}
                />

                <Box borderRadius={5} overflow={"hidden"} maxH={"300px"}>
                  {item?.media || item?.galleryPost?.length >= 1 ? (
                    <Pressable
                      width={"40%"}
                      alignSelf={"center"}
                      onPress={() => {
                        props.showFeedDetails(props?.subitem);
                        props.setIscommentItem(props?.subitem);
                        props?.setIsFullScreen(true);
                        props?.setIsCommentSlider(true);
                      }}
                    >
                      <LoadMedia item={item} showdetail={props?.showDetails} />
                    </Pressable>
                  ) : (
                    <LoadMedia item={item} showdetail={props?.showDetails} />
                  )}

                  {item?.media?.type?.startsWith("video") && (
                    <div>
                      <Pressable
                        onPress={() => {
                          showVIDEODetails(item);
                        }}
                      >
                        {/*<ChevronRightIcon />*/}
                      </Pressable>
                    </div>
                  )}

                  {item?.media?.type?.startsWith("video") && (
                    <div>
                      <Pressable
                        onPress={() => {
                          showVIDEODetails(item);
                        }}
                      >
                        {/*<ChevronLeftIcon />*/}
                      </Pressable>
                    </div>
                  )}
                </Box>
              </VStack>
            </HStack>

            <EditPostMenu
              item={item}
              showEditPopup={showEditPopup}
              currentUser={currentUser}
              handleEditPost={handleEditPost}
              handleDeletePost={handleDeletePost}
              HandleReportComment={props?.HandleReportComment}
              handleShowOriginalText={handleShowOriginalText}
              handleAcceptedPost={handleAcceptedPost}
            />

            {/* like reply */}
            <AHStack
              gap={3}
              alignItems={"center"}
              width={"100%"}
              justifyContent={"space-between"}
              space={20}
              paddingHorizontal={10}
            >
              <HStack pl={2} mt={1} left={10} alignItems={"center"}>
                {item?.impressions?.filter(
                  (x) => x?.id == currentUser?.id && x?.impression == "Like",
                ).length > 0 ? (
                  <Pressable
                    isDisabled={!isOnline}
                    onPress={() => {
                      handleremoveLike(item, "Like");
                    }}
                    p={1.5}
                    px={2}
                    disabled={isLikeLoading}
                    _disabled={{ opacity: 0.6 }}
                    _hover={{
                      backgroundColor: "AVColor.hovercolor2",
                      borderRadius: 5,
                    }}
                  >
                    <HStack alignItems={"center"} space={1}>
                      <LikeIcon size={"18px"} color="#32AE78" />
                      <Text color="#32AE78" fontSize={"15px"} mt={1}>
                        {Loc.currentLang.menu.like}
                      </Text>
                    </HStack>
                  </Pressable>
                ) : (
                  <Pressable
                    isDisabled={!isOnline}
                    onPress={() => handleLikePost(item, "Like")}
                    p={1.5}
                    px={2}
                    disabled={isLikeLoading}
                    _disabled={{ opacity: 0.6 }}
                    _hover={{
                      backgroundColor: "AVColor.hovercolor2",
                      borderRadius: 5,
                    }}
                  >
                    <HStack alignItems={"center"} space={1}>
                      <LikeIcon
                        size={"18px"}
                        color="AVColor.secondaryText"
                      />
                      <Text
                        color="AVColor.secondaryText"
                        fontSize={"15px"}
                        mt={1}
                      >
                        {Loc.currentLang.menu.like}
                      </Text>
                    </HStack>
                  </Pressable>
                )}

                <Box>
                  <Pressable
                    isDisabled={!isOnline}
                    onPress={() => {
                      setShowFeedbackImpressions(!showFeedbackImpressions);
                    }}
                    p={1.5}
                    px={2}
                    disabled={isLikeLoading}
                    _disabled={{ opacity: 0.6 }}
                    _hover={{
                      backgroundColor: "AVColor.hovercolor2",
                      borderRadius: 5,
                    }}
                  >
                    <AHStack alignItems="center" gap={"5px"}>
                      <ChatIcon
                        size={"18px"}
                        color={
                          item?.impressions?.filter(
                            (x) =>
                              x?.id == currentUser?.id &&
                              x?.impression !== "Like",
                          ).length > 0
                            ? "#32AE78"
                            : "AVColor.secondaryText"
                        }
                      />
                      <Text
                        color={
                          item?.impressions?.filter(
                            (x) =>
                              x?.id == currentUser?.id &&
                              x?.impression !== "Like",
                          ).length > 0
                            ? "#32AE78"
                            : "AVColor.secondaryText"
                        }
                        fontSize={"15px"}
                        mt={1}
                      >
                        {Loc.currentLang.menu.feedback}
                      </Text>
                    </AHStack>
                  </Pressable>

                  {showFeedbackImpressions && (
                    <HStack
                      space={2}
                      backgroundColor={"gray.100"}
                      ref={menuRef}
                      position={"absolute"}
                      top={"-40px"}
                      alignItems={"center"}
                      justifyContent={"space-around"}
                      px={2}
                      py={1}
                      borderRadius={"full"}
                    >
                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "Like");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.like}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.like }}
                              alt="like"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>

                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "Unlike");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.unlike}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.unlike }}
                              alt="unlike"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>

                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "heart");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.heart}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.heart }}
                              alt="heart"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>
                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "Wow");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.wow}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.wow }}
                              alt="startruck"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>

                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "Lol");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.lol}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.lol }}
                              alt="Lol"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>

                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "Cheer");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.cheer}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.cheer }}
                              alt="fan"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>

                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "Question");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.question}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.question }}
                              alt="Question"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>

                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "broken");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.broken}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.broken }}
                              alt="broken"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>
                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "Sad");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.sad}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.sad }}
                              alt="sad"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>

                      <Pressable
                        onPress={() => {
                          handleLikePost(item, "Mad");
                          setShowFeedbackImpressions(false);
                        }}
                      >
                        <HStack>
                          <Tooltip
                            title={Loc.currentLang.impression.mad}
                            enterDelay={100}
                            leaveDelay={0}
                            arrow
                            placement="top"
                          >
                            <Image
                              source={{ uri: settings.mad }}
                              alt="Mad"
                              size="20px"
                            />
                          </Tooltip>
                        </HStack>
                      </Pressable>
                    </HStack>
                  )}
                </Box>

                {(item?.allowReply == true ||
                  currentUser?.id === item?.person?.id) && (
                    <Pressable
                      isDisabled={!isOnline}
                      onPress={() => {
                        handleReplyPost(item);
                        SetType("ReplyComment");
                        setParentId(item.id);
                        setCmdParent(item);
                        handleClick();
                      }}
                      p={1.5}
                      px={2}
                      _hover={{
                        backgroundColor: "AVColor.hovercolor2",
                        borderRadius: 5,
                      }}
                    >
                      <HStack alignItems={"center"} space={1}>
                        <ReplyIcon
                          size={"18px"}
                          color="AVColor.secondaryText"
                        />
                        <Text
                          color="AVColor.secondaryText"
                          fontSize={"15px"}
                          mt={1}
                        >
                          {Loc.currentLang.menu.reply}
                        </Text>
                      </HStack>
                    </Pressable>
                  )}
              </HStack>

              <AHStack
                gap={3}
                justifyContent={"flex-end"}
                flex={1}
                paddingLeft={5}
              >
                {item?.impressions?.filter((x) => x.impression == "Wow")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "Wow")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.wow }}
                        alt="startruck"
                        size="18"
                      />
                      <Text fontSize={11} fontWeight={"bold"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "Wow",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "Lol")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "Lol")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.lol }}
                        alt="startruck"
                        size="18"
                      />
                      <Text fontSize={11} fontWeight={"bold"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "Lol",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "Like")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "Like")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.like }}
                        alt="Like"
                        size="18"
                      />
                      <Text fontWeight="bold" fontSize="11">
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "Like",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "Unlike")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "Unlike")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.unlike }}
                        alt="unLike"
                        size="18"
                      />
                      <Text fontWeight={"bold"} fontSize={"11"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "Unlike",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "Cheer")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "Cheer")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.cheer }}
                        alt="sad"
                        size="18"
                      />
                      <Text fontWeight={"bold"} fontSize={"11"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "Cheer",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "Question")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "Question")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.question }}
                        alt="sad"
                        size="18"
                      />
                      <Text fontWeight={"bold"} fontSize={"11"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "Question",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "Sad")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "Sad")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.sad }}
                        alt="sads"
                        size="18"
                      />
                      <Text fontWeight={"bold"} fontSize={"11"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "Sad",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "heart")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "heart")}
                  >
                    {" "}
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.heart }}
                        alt="sad"
                        size="18"
                      />
                      <Text fontWeight={"bold"} fontSize={"11"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "heart",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "broken")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "broken")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.broken }}
                        alt="sad"
                        size="18"
                      />
                      <Text fontWeight={"bold"} fontSize={"11"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "broken",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}

                {item?.impressions?.filter((x) => x.impression == "Mad")
                  .length > 0 && (
                  <Pressable
                    onPress={() => props?.handleImpression(item, "Mad")}
                  >
                    <AHStack
                      gap={3}
                      borderRadius={"20px"}
                      alignItems={"center"}
                      backgroundColor={"#def2ff"}
                      paddingHorizontal={"5px"}
                      paddingVertical={"2px"}
                    >
                      <Image
                        source={{ uri: settings.mad }}
                        alt="mad"
                        size="18"
                      />
                      <Text fontWeight={"bold"} fontSize={"11"}>
                        {
                          item?.impressions?.filter(
                            (x) => x.impression == "Mad",
                          ).length
                        }
                      </Text>
                    </AHStack>
                  </Pressable>
                )}
              </AHStack>
            </AHStack>

            {isAddComment && (
              <>
                <VStack flex={1} width={"100%"}>
                  <HStack alignItems="center" px={3} flex={1} space={2}>
                    <Pressable
                      onPress={() =>
                        navigate(
                          `/profile/${currentUser?.id}/${currentUser?.region}`,
                          { state: { user: currentUser } },
                        )
                      }
                    >
                      <EntityProfilePic
                        width={35}
                        height={35}
                        link={Person.getFk(Person.self())}
                      />
                    </Pressable>
                    <HStack flex={1} marginTop={1}>
                      {showEmoji && (
                        <Box
                          ref={menuRef}
                          position={"absolute"}
                          bottom={"60px"}
                          right={"50px"}
                        >
                          {/* <Picker onEmojiClick={ onEmojiClick } />*/}
                          <AVEmojiPicker
                            onEmojiSelect={(e) => {
                              return onEmojiClick(e);
                            }}
                          />
                        </Box>
                      )}

                      <HStack flex={1} space={1} my={2} width={"100%"}>
                        <HStack
                          flex={2}
                          borderRadius={"full"}
                          bgColor={"AVColor.inputBg"}
                        >
                          <Input
                            ref={commentValueRef}
                            width={"full"}
                            size="xl"
                            autoFocus={true}
                            outlineColor={"transparent"}
                            _focus={{
                              bgColor: "AVColor.inputBg",
                              borderRadius: "full",
                            }}
                            focusOutlineColor={"transparent"}
                            value={commentValue}
                            placeholder={
                              Loc.currentLang.placeholderText.commentPlaceholder
                            }
                            borderRadius={0}
                            borderWidth={0}
                            color={"black"}
                            placeholderTextColor={"gray.500"}
                            onKeyPress={handleKeyPress}
                            onChangeText={(e) =>
                              handleAddComment(e, false, false)
                            }
                          />
                        </HStack>

                        <HStack alignItems={"center"}>
                          {(commentValue?.trim()?.length > 0 ||
                            showFilePicker ||
                            showEmoji) && (
                            <Button
                              bgColor={"none"}
                              isLoading={isCommentLoading}
                              _loading={{ bgColor: "AVColor.primary" }}
                              onPress={() => handlePostComment(false)}
                            >
                              <PaperPlaneIcon
                                color={"AVColor.primary"}
                                size={"25px"}
                              />
                            </Button>
                          )}
                          <Pressable
                            onPress={() => {
                              setShowEmoji(!showEmoji);
                            }}
                            mx={2}
                          >
                            <SvgIcon name="HAPPY" size={20} />
                          </Pressable>

                          <HStack space={3}>
                            <Button
                              padding={"5px"}
                              rounded={"full"}
                              _hover={{
                                opacity: 0.8,
                              }}
                              onPress={() => {
                                setCommentTo(item);
                                setImages([]);
                                SetType("ReplyComment");
                                setParentId(item.id);
                                setCmdParent(item);
                                setTimeout(() => {
                                  setShowAddComment(true);
                                }, 500);
                              }}
                              backgroundColor={"AVColor.primary"}
                            >
                              <AddIcon size={"8px"} color="AVColor.white" />
                            </Button>
                          </HStack>
                        </HStack>
                      </HStack>
                    </HStack>
                  </HStack>

                  <VStack justifyContent={"center"} alignItems={"center"}>
                    {showFilePicker && (
                      <Box
                        minHeight={220}
                        height={"auto"}
                        borderWidth="1"
                        rounded="sm"
                        borderStyle={"dashed"}
                        width={"90%"}
                        marginTop={2}
                        marginLeft={6}
                        justifyContent={"center"}
                      >
                        <div className="overflow_a scrollbar">
                          <input
                            type="file"
                            accept="image/jpeg,image/png,image/jfif,image/gif,video/mp4,"
                            multiple
                            hidden
                            ref={imageInputRef}
                            onChange={handleImages}
                          />
                          <HStack
                            my={3}
                            mx={5}
                            space={4}
                            alignItems={"center"}
                            zIndex={0}
                          >
                            {images.length > 0 || videos.length > 0 ? (
                              <RenderImages
                                images={images}
                                imageInputRef={imageInputRef}
                                setImages={setImages}
                                setvideos={setvideos}
                                videos={videos}
                              />
                            ) : (
                              <Box
                                borderWidth={1}
                                borderRadius={5}
                                overflow={"hidden"}
                                borderColor={"avcolors.black"}
                                borderStyle={"none"}
                                maxH={"300px"}
                                height="100%"
                                width="100%"
                                overflowY={"auto"}
                              >
                                <Pressable
                                  onPress={() =>
                                    imageInputRef?.current?.click()
                                  }
                                >
                                  <VStack
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    minH={"150px"}
                                    space={2}
                                  >
                                    <Box
                                      backgroundColor={"AVColor.grey"}
                                      p={2}
                                      borderRadius="full"
                                    >
                                      <AddIcon color={"AVColor.secondary"} />
                                    </Box>
                                    <Text fontSize={14} color={"AVColor.grey"}>
                                      {Loc.currentLang.menu.imageOrVideo}
                                    </Text>
                                  </VStack>
                                </Pressable>
                              </Box>
                            )}
                          </HStack>
                        </div>
                      </Box>
                    )}
                  </VStack>
                </VStack>
              </>
            )}
          </VStack>
        </Box>

        {props.type == "feed"
          ? item?.children
              ?.slice(0, 0)
              .map((subitem) => (
                <Comment
                  showAddComment={showAddComment}
                  setShowAddComment={setShowAddComment}
                  SetType={SetType}
                  setParentId={setParentId}
                  setCmdParent={setCmdParent}
                  subitem={subitem}
                  data={props}
                  key={subitem?.id}
                  handleEditPost={props?.handleEditPost}
                  handleDeleteComment={props?.handleDeleteComment}
                  HandleReportComment={props?.HandleReportComment}
                />
              ))
          : item?.children?.map((subitem) => (
              <Comment
                showAddComment={showAddComment}
                setShowAddComment={setShowAddComment}
                SetType={SetType}
                setParentId={setParentId}
                setCmdParent={setCmdParent}
                subitem={subitem}
                data={props}
                key={subitem?.id}
                handleEditPost={props?.handleEditPost}
                handleDeleteComment={props?.handleDeleteComment}
                HandleReportComment={props?.HandleReportComment}
              />
            ))}
      </VStack>

      {showModal && (
        <EditPostpopup
          setItem={setItem}
          setFeedChunks={props?.setFeedChunks}
          setpreviewitem={undefined}
          feedChunks={props?.feedChunks}
          setShowCreatePost={setShowModal}
          item={item}
          windowDimensions={undefined}
          headerHeight={undefined}
          showModal={undefined}
          reload={undefined}
          setShowDetails={undefined}
          userInfo={props?.Postdata}
          isHuddlePostTab={props?.isHuddlePostTab}
          paySend={paySend}
          setPaySend={setPaySend}
          subject={subject}
          setSubject={setSubject}
          estimate={estimate}
          setEstimate={setEstimate}
          showBoostPostPopup={showBoostPostPopup}
          setShowBoostPostPopup={setShowBoostPostPopup}
          showCreditsPopup={showCreditsPopup}
          setShowCreditsPopup={setShowCreditsPopup}
          sharedPlan={sharedPlan}
          setSharedPlan={setSharedPlan}
        />
      )}

      {showAddComment && (
        <CreatePostpopup
          visibilityPermission={""}
          setShowCreatePost={setShowAddComment}
          Postdata={
            props?.data?.owner?.type === "Event"
              ? props?.data
              : props?.Postdata ||
                props?.userInfo ||
                props?.data?.userInfo ||
                null
          }
          setFeedChunks={props?.setFeedChunks}
          feedChunks={props?.feedChunks}
          handleAddComment={handleAddComment}
          handlePostComment={handlePostComment}
          showAddComment={showAddComment}
          setShowAddComment={setShowAddComment}
          setCommentMedia={setCommentMedia}
          isHuddlePostTab={false}
          boostPostOwner={
            showAddComment ? props?.data?.owner : props?.Postdata?.owner
          }
          paySend={paySend}
          setPaySend={setPaySend}
          subject={subject}
          setSubject={setSubject}
          estimate={estimate}
          setEstimate={setEstimate}
          visibility={
            showAddComment && item?.visibility?.length > 0
              ? item?.visibility
              : cmdParent?.visibility
          }
          showBoostPostPopup={showBoostPostPopup}
          setShowBoostPostPopup={setShowBoostPostPopup}
          showCreditsPopup={showCreditsPopup}
          setShowCreditsPopup={setShowCreditsPopup}
          sharedPlan={sharedPlan}
          setSharedPlan={setSharedPlan}
        />
      )}

      {showConfirmLinkPopup && (
        <AVConfirmLinkPopup
          url={clickedUrl}
          handleCancel={() => setShowConfirmLinkPopup?.(false)}
        />
      )}
    </>
  );
};

const RenderImages = ({
  images,
  imageInputRef,
  setImages,
  videos,
  setvideos,
}) => {
  return (
    <div className="add_pics_inside1 p0">
      <div className="preview_actions">
        <AVAdd addEvent={() => imageInputRef.current.click()} />
      </div>
      <div
        className="small_white_circle"
        onClick={() => {
          setImages([]);
          setvideos([]);
        }}
      >
        <AVCancel
          callback={() => {
            setImages([]);
            setvideos([]);
          }}
          color={"#000000"}
          size={undefined}
        />
      </div>

      <div
        className={
          images.length === 1
            ? "preview1"
            : images.length === 2
              ? "preview2"
              : images.length === 3
                ? "preview3"
                : images.length === 4
                  ? "preview4 "
                  : images.length === 5
                    ? "preview5"
                    : images.length % 2 === 0
                      ? "preview6"
                      : "preview6 singular_grid"
        }
      >
        {videos?.map((img, i) => (
          <video controls width={"100%"} height={"auto"} src={img} key={i} />
        ))}

        {images.map((img, i) => (
          <img src={img} key={i} alt="" className="Image" />
        ))}
      </div>
    </div>
  );
};

const PostHeader = ({
  item,
  setItem,
  handleEditPopup,
  showEditPopup,
  handleDeletePost,
  handleEditPost,
  handleLikePost,
  menuRef,
  showModal,
  setShowModal,
  currentUser,
  handleremoveLike,
  handleDeleteComment,
  handleTranslateText,
  handleShowOriginalText,
  handleAcceptedPost,
  userInfo,
  isHuddlePostTab,
  paySend,
  setPaySend,
  subject,
  setSubject,
  estimate,
  setEstimate,
  showBoostPostPopup,
  setShowBoostPostPopup,
  showCreditsPopup,
  setShowCreditsPopup,
  sharedPlan,
  setSharedPlan,
  feedChunks,
  setFeedChunks,
}) => {
  let uri = AVlink.getTummb(item?.person);

  if (item?.person?.id === AV.Person.self().id) {
    let link = AV.Person.getLink(AV.Person.self());
    uri = AVlink.getTummb(link);
  }

  return (
    <>
      <AHStack padding={"12px"} justifyContent={"space-between"} width={"100%"}>
        <AHStack>
          <Link
            to="/"
            style={{
              backgroundImage: `url(${fallBackImage})`,
              backgroundRepeat: "no-repeat",
              width: 50,
              height: 50,
              borderRadius: "50%",
            }}
          >
            {uri && (
              <img
                src={uri}
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  objectFit: "contain",
                  backgroundColor: "#eeeeee",
                }}
                alt=""
              />
            )}

            {!uri && (
              <Box
                bgColor="AVColor.grey"
                width={"47px"}
                height={"47px"}
                rounded="full"
              >
                <img
                  src={LogoSvg}
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    objectFit: "contain",
                    backgroundColor: "#eeeeee",
                  }}
                />{" "}
              </Box>
            )}
          </Link>

          <AVStack justifyContent={"center"} marginLeft={8}>
            <AHStack justifyContent={"space-between"}>
              <Text fontSize={[16]} fontWeight={["bold"]}>
                {item?.person?.title}
              </Text>
              <AVStack alignItems={"flex-start"} justifyContent={"flex-start"}>
                <Pressable
                  onPress={() => {
                    handleEditPopup(item);
                  }}
                >
                  <MoreHorizontalIcon />
                </Pressable>
              </AVStack>
            </AHStack>
            <Text fontSize={[12, 14]}>
              <Moment element={Text} format="MMMM D, Y">
                {item?.lastUpdated}
              </Moment>
            </Text>
          </AVStack>
        </AHStack>
      </AHStack>

      {showEditPopup && (
        <VStack
          ref={menuRef}
          position={"absolute"}
          rounded="lg"
          right={1}
          top={"26px"}
          width="125px"
          height="70px"
          bgColor="#fff"
          borderColor="coolGray.200"
          borderWidth="1"
          _dark={{
            borderColor: "coolGray.600",
          }}
          shadow={3}
        >
          {item.modStatus !== "NR" && (
            <>
              <Pressable
                onPress={() => {
                  handleEditPost(item);
                }}
              >
                <HStack bottom={1}>
                  <EditIcon size="md" marginTop={3} marginLeft={3} />
                  <Text margin={"5px"} marginTop={3} marginLeft={5}>
                    {Loc.currentLang.menu.edit}
                  </Text>
                </HStack>
              </Pressable>
              <Divider my="1" _light={{ bg: "gray.100" }} top={-10} />
              <Pressable
                width={"100%"}
                onPress={() => {
                  handleDeleteComment(item);
                }}
              >
                <HStack bottom={5}>
                  <DeleteIcon size="md" marginTop={3} marginLeft={3} />
                  <Text margin={"5px"} marginTop={3} marginLeft={5}>
                    {Loc.currentLang.menu.delete}
                  </Text>
                </HStack>
              </Pressable>
            </>
          )}

          {/* NR Status - Moderation Actions */}
          {item.modStatus === "NR" && (
            <>
              <Pressable
                onPress={() => handleAcceptedPost(item)}
                p={2}
                _hover={{ backgroundColor: "AVColor.hovercolor2" }}
              >
                <HStack alignItems="center" space={2}>
                  <TickIcon size="18px" color="AVColor.secondaryText" />
                  <Text>{Loc.currentLang.menu.accepted}</Text>
                </HStack>
              </Pressable>
              <Divider thickness="0.5" />
              <Pressable
                onPress={() => handleDeleteComment(item)}
                p={2}
                _hover={{ backgroundColor: "AVColor.hovercolor2" }}
              >
                <HStack alignItems="center" space={2}>
                  <CrossIcon size="18px" color="AVColor.secondaryText" />
                  <Text>{Loc.currentLang.menu.rejected}</Text>
                </HStack>
              </Pressable>
            </>
          )}
        </VStack>
      )}

      {showModal && (
        <EditPostpopup
          setFeedChunks={setFeedChunks}
          setpreviewitem={undefined}
          feedChunks={feedChunks}
          setItem={setItem}
          setShowCreatePost={setShowModal}
          item={item}
          windowDimensions={undefined}
          headerHeight={undefined}
          showModal={undefined}
          reload={undefined}
          setShowDetails={undefined}
          userInfo={userInfo}
          isHuddlePostTab={isHuddlePostTab}
          paySend={paySend}
          setPaySend={setPaySend}
          subject={subject}
          setSubject={setSubject}
          estimate={estimate}
          setEstimate={setEstimate}
          showBoostPostPopup={showBoostPostPopup}
          setShowBoostPostPopup={setShowBoostPostPopup}
          showCreditsPopup={showCreditsPopup}
          setShowCreditsPopup={setShowCreditsPopup}
          sharedPlan={sharedPlan}
          setSharedPlan={setSharedPlan}
        />
      )}
    </>
  );
};

const PostActions = ({
  item,
  handleLikePost,
  handleReplyPost,
  isLikeLoading,
}) => {
  return (
    <AHStack
      gap={10}
      alignItems={"center"}
      paddingHorizontal={10}
      paddingVertical={5}
    >
      <Pressable
        onPress={() => handleLikePost(item, "Like")}
        disabled={isLikeLoading}
        _disabled={{ opacity: 0.6 }}
      >
        <HStack alignItems={"center"} space={1}>
          <Text fontWeight={"bold"} fontSize={"16px"} mt={"1px"}>
            {Loc.currentLang.menu.like}
          </Text>
          <LikeIcon size={"20px"} color="gray.400" />
        </HStack>
      </Pressable>
      <Pressable onPress={handleReplyPost}>
        <HStack alignItems={"center"} space={1}>
          <Text fontWeight={"bold"} fontSize={"16px"} mt={"1px"}>
            {Loc.currentLang.menu.reply}
          </Text>
          <ReplyIcon size={"20px"} />
        </HStack>
      </Pressable>

      <AHStack gap={3} justifyContent={"flex-end"} flex={1} paddingLeft={5}>
        {item?.impressions.filter((x) => x.impression == "startruck").length >
          0 && (
          <AHStack
            gap={3}
            borderRadius={"20px"}
            alignItems={"center"}
            backgroundColor={"#def2ff"}
            paddingHorizontal={"5px"}
            paddingVertical={"2px"}
          >
            <Image source={{ uri: startruck }} alt="startruck" size="18" />
            <Text fontSize={11} fontWeight={"bold"}>
              {
                item?.impressions.filter((x) => x.impression == "startruck")
                  .length
              }
            </Text>
          </AHStack>
        )}

        {item?.impressions.filter((x) => x.impression == "Like").length > 0 && (
          <AHStack
            gap={3}
            borderRadius={"20px"}
            alignSelf={"flex-end"}
            backgroundColor={"#def2ff"}
            paddingHorizontal={"5px"}
            paddingVertical={"2px"}
          >
            <Image source={{ uri: like }} alt="Like" size="18" />
            <Text fontWeight={"bold"} fontSize={"11"}>
              {item?.impressions.filter((x) => x.impression == "Like").length}
            </Text>
          </AHStack>
        )}

        {item?.impressions.filter((x) => x.impression == "fan").length > 0 && (
          <AHStack
            gap={3}
            borderRadius={"20px"}
            alignItems={"center"}
            backgroundColor={"#def2ff"}
            paddingHorizontal={"5px"}
            paddingVertical={"2px"}
          >
            <Image source={{ uri: fan }} alt="sad" size="18" />
            <Text fontWeight={"bold"} fontSize={"11"}>
              {item?.impressions.filter((x) => x.impression == "fan").length}
            </Text>
          </AHStack>
        )}

        {item?.impressions.filter((x) => x.impression == "sads").length > 0 && (
          <AHStack
            gap={3}
            borderRadius={"20px"}
            alignItems={"center"}
            backgroundColor={"#def2ff"}
            paddingHorizontal={"5px"}
            paddingVertical={"2px"}
          >
            <Image source={{ uri: sads }} alt="sads" size="18" />
            <Text fontWeight={"bold"} fontSize={"11"}>
              {item?.impressions.filter((x) => x.impression == "sads").length}
            </Text>
          </AHStack>
        )}
      </AHStack>
    </AHStack>
  );
};

const LoadMedia = ({ item, isDetail = false, showdetail }) => {
  const [videoStatus, setVideoStatus] = useState<any>("");
  const [videoItem, setVideoItem] = useState<any>("");

  return (
    <AVStack width={"100%"}>
      {!item?.media?.type?.startsWith("application") ||
      item?.galleryPost?.length > 0 ? (
        <GridView
          item={item}
          setVideoStatus={setVideoStatus}
          setVideoItem={setVideoItem}
          isComment={true}
        />
      ) : (
        <GridView
          item={item}
          setVideoStatus={setVideoStatus}
          setVideoItem={setVideoItem}
          isComment={true}
        />
      )}
    </AVStack>
  );
};

const HtmlPostViewer = ({ text }: { text: string }) => {
  const [more, setMore] = useState(false);

  const htmlPostbgImg = useMemo(() => {
    if (!text) return false;
    return /background-image\s*:\s*(?!\s*(none|unset)\b)[^;]+/i.test(text);
  }, [text]);

  // SHOW MORE / LESS LOGIC
  const plain = sanitizedText(text)?.outputString ?? "";
  const words = plain.trim().split(/\s+/);
  const wordCount = words.length;

  let shortHTML = text;
  if (wordCount > 70) {
    const limited = words.slice(0, 66).join(" ") + "...";
    shortHTML = `<div>${limited}</div>`;
  }

  let finalHTML = more ? text : shortHTML;

  // BG IMAGE HEIGHT FIX
  if (htmlPostbgImg) {
    finalHTML = finalHTML.replace(
      /<div([^>]*)style="([^"]*)"/,
      (match, p1, p2) => {
        if (!/height\s*:/.test(p2)) {
          if (
            !/background\s*:\s*(none|unset)/i.test(p2) &&
            !/background-image\s*:\s*(?!\s*(none|unset)\b)[^;]+/i.test(p2)
          ) {
            return `<div${p1} style="${p2}; height: 480px"`;
          }
        }
        return match;
      },
    );
  }

  // REMOVE FIGURE
  finalHTML = finalHTML.replace(/<figure[^>]*>(.*?)<\/figure>/g, "$1");

  // WIDTH & HEIGHT
  let divWidth = "100%";
  let divHeight = "auto";

  const divStyleMatch = finalHTML.match(
    /<div[^>]*style="[^"]*width\s*:\s*(\d+)px;[^"]*height\s*:\s*(\d+)px;?/i,
  );

  if (divStyleMatch) {
    divWidth = `${divStyleMatch[1]}px`;
    divHeight = `${divStyleMatch[2]}px`;
  }

  return (
    <Box width="100%">
      <div
        className="htmlPost"
        title="post"
        style={{
          maxHeight: "max-content",
          width: htmlPostbgImg ? divWidth : "100%",
          minWidth: htmlPostbgImg ? divWidth : "100%",
          outline: "none",
          userSelect: "text",
          cursor: "default",
        }}
        contentEditable={htmlPostbgImg}
        suppressContentEditableWarning={true}
        onInput={(e) => e.preventDefault()}
        onKeyDown={(e) => e.preventDefault()}
        onPaste={(e) => e.preventDefault()}
        onFocus={(e) => (e.target as HTMLElement).blur()}
        dangerouslySetInnerHTML={{ __html: finalHTML }}
      />

      {wordCount > 70 && (
        <TouchableOpacity onPress={() => setMore(!more)}>
          <Text color="#32AE78" mt={1}>
            {more ? "less" : "more"}
          </Text>
        </TouchableOpacity>
      )}
    </Box>
  );
};

export default Comment;
